import css from './style.module.scss';
import Image from 'next/image';
import Wrap from '../Wrap';
import cls from '../../util/cls';
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion';
import { Fragment, useEffect, useState } from 'react';
import IconPause from '../../svg/icon-pause.svg';
import IconPlay from '../../svg/icon-play.svg';

function Regular ({ shrink, images, unwrapped = false }) {
	const [isLooping, setIsLooping] = useState(true)
		, [i, setI] = useState(0);

	useEffect(() => {
		setI(0);
		setIsLooping(images.length > 1);
	}, [images]);

	useEffect(() => {
		if (!isLooping) return;

		const id = setInterval(() => setI(i => ++i > images.length - 1 ? 0 : i), 7000);
		return () => clearInterval(id);
	}, [i, isLooping]);

	const onThumbClick = j => () => {
		setIsLooping(l => i === j ? !l : false);
		setI(j);
	};

	const El = unwrapped ? 'div' : Wrap;

	return (
		<El {...(unwrapped ? {} : { wide: true })} className={cls(css.gallery, {
			[css.shrink]: shrink,
			[css.looping]: isLooping,
			[css.unwrapped]: unwrapped,
		})}>
			<AnimatePresence initial={false} exitBeforeEnter>
				<motion.div
					key={i}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.5 }}
				>
					<Image unoptimized
						src={images?.[i]?.url}
						width={1720}
						height={920}
						loading="eager"
					/>
				</motion.div>
			</AnimatePresence>
			<div className={css.thumbnails}>
				<AnimateSharedLayout>
					{images.map(({ url }, j) => (
						<button
							key={j}
							className={cls({ [css.active]: j === i })}
							onClick={onThumbClick(j)}
						>
							{j === i && <motion.span layoutId="active" transition={{ duration: 0.5, ease: 'easeInOut' }} />}
							<div>
								<Image unoptimized
									src={url.replace('5160x2760', '240x144')}
									width={80}
									height={48}
								/>
							</div>
							<IconPause className={css.pause} />
							<IconPlay className={css.play} />
						</button>
					))}
				</AnimateSharedLayout>
			</div>
		</El>
	);
}

function Stacked ({ children, images, childrenLeft }) {
	return (
		<Wrap wide grid className={cls(css.gallery, css.stacked)}>
			{childrenLeft && children}
			{images.map((image, i) => (
				<Fragment key={image.url}>
					<Image unoptimized
						src={image.url}
						width={1720}
						height={920}
						loading={i === 0 ? 'eager' : void 0}
					/>
					{i=== 0 && !childrenLeft && children}
				</Fragment>
			))}
		</Wrap>
	);
}

export default function Gallery ({
	images = [],
	shrink = false,
	stacked = false,
	childrenLeft = false,
	unwrapped = false,
	children,
}) {
	if (images.length === 0)
		return children ?? null;

	if (stacked) return <Stacked images={images}>{children}</Stacked>;
	return (
		<>
			{childrenLeft && children}
			<Regular
				shrink={shrink}
				images={images}
				unwrapped={unwrapped}
			/>
			{!childrenLeft && children}
		</>
	);
}
